<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <el-form :model="form">
        <el-form-item label="事件名称：">
          <el-input v-model="form.eventName" disabled />
        </el-form-item>
        <el-form-item label="发生时间：">
          <item-input type="datetime-local" v-model="eventtime" style="width: 300px; height: 40px;  font-size: 20px;float: left;"></item-input>
        </el-form-item>
        <el-form-item label="手术体位：">
          <el-radio-group v-model="form.surgicalPosition" style="display: flex;flex-direction: column; gap: 10px;  flex-wrap: wrap;
    height: 150px;">
          <el-radio
                v-for="(position, index) in positions"
                :key="index"
                :label="position.name"
                style="display: flex;align-items:center;margin: 0;width: 200px;"
              >
                <div style="display: flex;  align-items: center; gap: 4px;">
                  <img
                    :src="position.image"
                    style="width: 20px; height: 20px; object-fit: contain;"
                    alt="体位图片"
                  />
                  <span>{{ position.name }}</span>
                </div>
              </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
        </div>
        <CloseButton type="confirm" @confirm="BfTw" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `AnesTWBF`,
    props: {

    },
    data() {
        return {
            title: `体位摆放`,
            form: {
                eventName: `摆放体位`,
                eventTime: ``,
                surgicalPosition: ``
            },
            token: this.$route.query.token,
            id: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            data: {},
            eventtime: this.$moment().format(`YYYY/MM/DD HH:mm`),
            positions: [
                {
                    name: `分腿位`,
                    image: `../../static/img/TwImg/分腿位.svg`
                },
                {
                    name: `俯卧位`,
                    image: `../../static/img/TwImg/俯卧位.svg`
                },
                {
                    name: `俯卧折刀位`,
                    image: `../../static/img/TwImg/俯卧折刀位.svg`
                },
                {
                    name: `截石位`,
                    image: `../../static/img/TwImg/截石位.svg`
                },
                {
                    name: `颈伸仰卧位`,
                    image: `../../static/img/TwImg/颈伸仰卧位.svg`
                },
                {
                    name: `沙滩椅位`,
                    image: `../../static/img/TwImg/沙滩椅位.svg`
                },
                {
                    name: `水平仰卧位`,
                    image: `../../static/img/TwImg/水平仰卧位.svg`
                },
                {
                    name: `头低脚高剪刀位`,
                    image: `../../static/img/TwImg/头低脚高剪刀位.svg`
                }, {
                    name: `头低脚高仰卧位`,
                    image: `../../static/img/TwImg/头低脚高仰卧位.svg`
                },
                {
                    name: `头高脚低仰卧位`,
                    image: `../../static/img/TwImg/头高脚低仰卧位.svg`
                },
                {
                    name: `头高足低剪刀位`,
                    image: `../../static/img/TwImg/头高足低剪刀位.svg`
                },
                {
                    name: `膝胸位`,
                    image: `../../static/img/TwImg/膝胸位.svg`
                },
                {
                    name: `斜仰卧截石位`,
                    image: `../../static/img/TwImg/斜仰卧截石位.svg`
                },
                {
                    name: `右侧骑马射箭位`,
                    image: `../../static/img/TwImg/右侧骑马射箭位.svg`
                },
                {
                    name: `右侧卧折刀位`,
                    image: `../../static/img/TwImg/右侧卧折刀位.svg`
                },
                {
                    name: `右前倾卧位`,
                    image: `../../static/img/TwImg/右前倾卧位.svg`
                }, {
                    name: `左侧骑马射箭位`,
                    image: `../../static/img/TwImg/左侧骑马射箭位.svg`
                },
                {
                    name: `左侧卧位`,
                    image: `../../static/img/TwImg/左侧卧位.svg`
                },
                {
                    name: `左侧卧折刀位`,
                    image: `../../static/img/TwImg/左侧卧折刀位.svg`
                },
                {
                    name: `左前倾卧位`,
                    image: `../../static/img/TwImg/左前倾卧位.svg`
                },
                {
                    name: `自由体位`,
                    image: `../../static/img/TwImg/自由体位.svg`
                }
            ],
            msg: `closeWindow`,
            AfterOtherEventClickProc: this.$root.AfterOtherEventClickProc,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
    },
    computed: {
    },
    methods: {
        BfTw() {
            let that = this
            if (!that.check()) return false
            debugger
            var eventname = this.form.eventName + `(` + this.form.surgicalPosition + `)`
            return new Promise((resolve) => {
                let req = that.myaxios.post(`/api/AcisSystem/Event/CustomEvent?name=${eventname}`)
                req.then(data => {
                    debugger
                    var eventobj = {
                        id: 0,
                        dic_event_id: data.id,
                        biz_surgery_info_id: this.id,
                        enum_record_type: this.recordType,
                        is_continue: false,
                        is_remind: false,
                        occur_time: this.eventtime
                    }
                    let req2 = that.myaxios.post(`/api/Intraoperative/Anaesthesia/PostOccurEvent`, eventobj)
                    req2.then(data2 => {
                        that.data = { id: data2.id }
                        that.msg = `ok`
                        that.sendMessage()
                    })
                }).catch(e => { console.log(e) })
            })
        },
        check() {
            if (this.form.surgicalPosition === ``) {
                this.$message.warning(`请选择手术摆放体位!`)
                return false
            }
            return true
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/AnesTWBF.vue